/**
 * Schedule Anchor (Spoor 2, Verlof MVP — AD-5)
 *
 * The fixed anchor date used to determine A/B week-type parity: the
 * number of *whole weeks* between this Monday and a target date's Monday,
 * modulo 2. This is deliberately NOT ISO-week-number parity (see AD-5) --
 * ISO week numbers reset every year and a 53-ISO-week year would otherwise
 * produce two consecutive weeks of the same type across the year boundary.
 *
 * `SCHEDULE_ANCHOR_DATE` must be a Monday. Chosen as an arbitrary Monday
 * matching the existing A/B pattern already in use for `work_schedule_entries`
 * (Week A) at the time this resolver was introduced.
 */
export const SCHEDULE_ANCHOR_DATE = '2026-01-05';
//# sourceMappingURL=scheduleAnchor.js.map